import * as React from 'react';
import {classNames, variationName} from '@shopify/react-utilities/styles';
import {Button} from '../Button';
import {Text} from '../Text';
import {Section} from '../Section';
import {BackgroundColors} from '../Types';
import styles from './ContentBlock.scss';

interface ContentBlockProps {
  heading?: string | null;
  subhead?: string | React.ReactElement<any>;
  cta?: string;
  url?: string;
  copy?: React.ReactNode;
  theme?: BackgroundColors;
  className?: string;
}

export function ContentBlock(props: ContentBlockProps) {
  const {heading, subhead, cta, url, copy, theme = 'white', className} = props;

  return (
    <Section className={classNames(className, styles[variationName('Theme', theme)])}>
      <div className={styles.Content}>
        <div className={styles.Header}>
          <Text className={styles.Heading} text={heading} type="h2" inheritColor />
          {subhead && <Text text={subhead} type="subhead2" component="p" inheritColor />}
          {cta && <Button label={cta} url={url} />}
        </div>
        {copy && (
          <Text type="regular" component="p" inheritColor className={styles.Copy} text={copy} />
        )}
      </div>
    </Section>
  );
}
